export default function validate(values, props) {
    const { messages } = props
    const errors = {}

    if (!values.logonId || !values.logonId.trim()) {
        errors.logonId = messages.errors.required({})
    } else if (!values.logonId.includes('@') || !values.logonId.includes('.')) {
        errors.logonId = messages.errors.invalid({ field: messages.loginForm.logonId() })
    }
    return errors
}
